import { Injectable, Injector, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Observable, from, of, BehaviorSubject, concat } from 'rxjs';
import { filter, flatMap, distinct, toArray, first } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';

function BreadcrumbsComponent_ol_0_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", crumb_r3.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(crumb_r3.text);
} }
function BreadcrumbsComponent_ol_0_li_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(crumb_r3.text);
} }
const _c0 = function (a0) { return { "breadcrumbs__item--active": a0 }; };
function BreadcrumbsComponent_ol_0_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 3);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_ol_0_li_1_a_1_Template, 2, 2, "a", 4);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_ol_0_li_1_span_2_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const last_r4 = ctx.last;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, last_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", last_r4);
} }
function BreadcrumbsComponent_ol_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ol", 1);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_ol_0_li_1_Template, 3, 5, "li", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumbs_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", crumbs_r1);
} }
class BreadcrumbsConfig {
}
BreadcrumbsConfig.ɵfac = function BreadcrumbsConfig_Factory(t) { return new (t || BreadcrumbsConfig)(); };
BreadcrumbsConfig.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BreadcrumbsConfig, factory: BreadcrumbsConfig.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsConfig, [{
        type: Injectable
    }], null, null); })();

class BreadcrumbsUtils {
    static stringFormat(rawTemplate, data) {
        const templateRegex = new RegExp('{{[\\s]*[a-zA-Z.]+?[\\s]*}}', 'g');
        return rawTemplate.replace(templateRegex, (match) => {
            const keyRegex = new RegExp('([a-zA-Z.]+)', 'g');
            const key = match.match(keyRegex);
            if (!key || !key.length) {
                return match;
            }
            const value = BreadcrumbsUtils.leaf(data, key[0]);
            if (!value) {
                return key[0];
            }
            return value;
        });
    }
    static wrapIntoObservable(value) {
        if (value instanceof Observable) {
            return value;
        }
        if (this.isPromise(value)) {
            return from(Promise.resolve(value));
        }
        return of(value);
    }
    static isPromise(value) {
        return value && (typeof value.then === 'function');
    }
    /**
    * Access object nested value by giving a path
    *
    * @param obj The object you want to access value from
    * @param path The value path. e.g: `bar.baz`
    * @example
    *   const obj = { foo: { bar: 'Baz' } };
    *   const path = 'foo.bar';
    *   leaf(obj, path) // 'Baz'
    */
    static leaf(obj, path) {
        const result = path.split('.').reduce((value, el) => value[el] || {}, obj);
        return BreadcrumbsUtils.isEmptyObject(result) ? null : result;
    }
    ;
    /**
    * checks whether an object is empty or not
    *
    * @param object object to extract values from
    * @returns boolean
    */
    static isEmptyObject(obj) {
        if (typeof obj === 'object' && Object.prototype.toString.call(obj) === '[object Object]') {
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }
}

class BreadcrumbsResolver {
    resolve(route, state) {
        const data = route.routeConfig.data;
        const path = this.getFullPath(route);
        let text = typeof (data.breadcrumbs) === 'string' ? data.breadcrumbs : data.breadcrumbs.text || data.text || path;
        text = BreadcrumbsUtils.stringFormat(text, route.data);
        const crumbs = [{
                text,
                path
            }];
        return of(crumbs);
    }
    getFullPath(route) {
        return this.fetchFullPath(route.pathFromRoot);
    }
    fetchFullPath(routes) {
        return routes.reduce((path, route) => path += this.fetchRelativePath(route.url), '');
    }
    fetchRelativePath(urlSegments) {
        return urlSegments.reduce((path, urlSegment) => path += '/' + urlSegment.path, '');
    }
}

class BreadcrumbsService {
    constructor(route, router, config, injector) {
        this.route = route;
        this.router = router;
        this.config = config;
        this.injector = injector;
        this.breadcrumbs = new BehaviorSubject([]);
        this.defaultResolver = new BreadcrumbsResolver();
        this.router.events.pipe(filter((x) => x instanceof NavigationEnd))
            .subscribe((event) => {
            const routeRoot = router.routerState.snapshot.root;
            this.resolveCrumbs(routeRoot).pipe(flatMap((crumbs) => crumbs), distinct((crumb) => crumb.text), toArray(), flatMap((crumbs) => {
                if (this.config.postProcess) {
                    const postProcessedCrumb = this.config.postProcess(crumbs);
                    return BreadcrumbsUtils.wrapIntoObservable(postProcessedCrumb).pipe(first());
                }
                else {
                    return of(crumbs);
                }
            }))
                .subscribe((crumbs) => {
                this.breadcrumbs.next(crumbs);
            });
        });
    }
    get crumbs$() {
        return this.breadcrumbs;
    }
    getCrumbs() {
        return this.crumbs$;
    }
    resolveCrumbs(route) {
        let crumbs$;
        const data = route.routeConfig && route.routeConfig.data;
        if (data && data.breadcrumbs) {
            let resolver;
            if (data.breadcrumbs.prototype instanceof BreadcrumbsResolver) {
                resolver = this.injector.get(data.breadcrumbs);
            }
            else {
                resolver = this.defaultResolver;
            }
            const result = resolver.resolve(route, this.router.routerState.snapshot);
            crumbs$ = BreadcrumbsUtils.wrapIntoObservable(result).pipe(first());
        }
        else {
            crumbs$ = of([]);
        }
        if (route.firstChild) {
            crumbs$ = concat(crumbs$, this.resolveCrumbs(route.firstChild));
        }
        return crumbs$;
    }
}
BreadcrumbsService.ɵfac = function BreadcrumbsService_Factory(t) { return new (t || BreadcrumbsService)(ɵngcc0.ɵɵinject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(BreadcrumbsConfig), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
BreadcrumbsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BreadcrumbsService, factory: BreadcrumbsService.ɵfac });
BreadcrumbsService.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: BreadcrumbsConfig },
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.ActivatedRoute }, { type: ɵngcc1.Router }, { type: BreadcrumbsConfig }, { type: ɵngcc0.Injector }]; }, null); })();

class BreadcrumbsComponent {
    constructor(breadcrumbsService) {
        this.breadcrumbsService = breadcrumbsService;
        this.crumbs$ = this.breadcrumbsService.getCrumbs();
    }
}
BreadcrumbsComponent.ɵfac = function BreadcrumbsComponent_Factory(t) { return new (t || BreadcrumbsComponent)(ɵngcc0.ɵɵdirectiveInject(BreadcrumbsService)); };
BreadcrumbsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbsComponent, selectors: [["lib-breadcrumbs"]], decls: 2, vars: 3, consts: [["class", "breadcrumbs__container", 4, "ngIf"], [1, "breadcrumbs__container"], ["class", "breadcrumbs__item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "breadcrumbs__item", 3, "ngClass"], [3, "routerLink", 4, "ngIf"], [4, "ngIf"], [3, "routerLink"]], template: function BreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BreadcrumbsComponent_ol_0_Template, 2, 1, "ol", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.crumbs$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc2.NgClass, ɵngcc1.RouterLinkWithHref], pipes: [ɵngcc2.AsyncPipe], encapsulation: 2 });
BreadcrumbsComponent.ctorParameters = () => [
    { type: BreadcrumbsService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-breadcrumbs',
                template: `
    <ol *ngIf="crumbs$ | async as crumbs" class="breadcrumbs__container">
      <li *ngFor="let crumb of crumbs; let last = last"
        [ngClass]="{ 'breadcrumbs__item--active': last }"
        class="breadcrumbs__item"
      >
        <a *ngIf="!last" [routerLink]="crumb.path">{{ crumb.text }}</a>
        <span *ngIf="last">{{ crumb.text }}</span>
      </li>
    </ol>
  `
            }]
    }], function () { return [{ type: BreadcrumbsService }]; }, null); })();

class BreadcrumbsModule {
    static forRoot() {
        return {
            ngModule: BreadcrumbsModule,
            providers: [
                BreadcrumbsConfig,
                BreadcrumbsService
            ]
        };
    }
}
BreadcrumbsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BreadcrumbsModule });
BreadcrumbsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BreadcrumbsModule_Factory(t) { return new (t || BreadcrumbsModule)(); }, imports: [[
            CommonModule,
            RouterModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BreadcrumbsModule, { declarations: function () { return [BreadcrumbsComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [BreadcrumbsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule
                ],
                declarations: [BreadcrumbsComponent],
                exports: [BreadcrumbsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BreadcrumbsComponent, BreadcrumbsConfig, BreadcrumbsModule, BreadcrumbsResolver, BreadcrumbsService };

//# sourceMappingURL=exalif-ngx-breadcrumbs.js.map